import { render, staticRenderFns } from "./solder_paste_type.vue?vue&type=template&id=a38e9e44"
import script from "./solder_paste_type.vue?vue&type=script&lang=js"
export * from "./solder_paste_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports